import { BaseWebComponentView } from '../../../framework/BaseWebComponentView';
import {
  API_TYPE_GZ,
  API_TYPE_NIRVANA,
  WEB_COMPONENT_GZ_TITLE,
  WEB_COMPONENT_XDR_SEARCH_APP,
  WEB_COMPONENT_XDR_SEARCH_LIVE,
} from '../../../webcomponents.constants';
import _ from 'lodash';
import { ViewData } from '../types';
import { ToastSeverity } from '../../../ui/gzToastNotification/type';

export class XdrSearchTabPanelView extends BaseWebComponentView {
  public getDomElements(): void {
    this.dom.$detailsPanel = this.shadow.querySelector('gz-side-menu');
    this.dom.$historicalGzTab = this.shadow.querySelector('#historical-tab');
    this.dom.$liveGzTab = this.shadow.querySelector('#live-tab');
    this.dom.$tabGroup = this.shadow.querySelector('#search-app-tab-group');
    this.dom.$searchApp = this.shadow.querySelector(WEB_COMPONENT_XDR_SEARCH_APP);
    this.dom.$searchLive = this.shadow.querySelector(WEB_COMPONENT_XDR_SEARCH_LIVE);
    this.dom.$tabGroupTitle = this.shadow.querySelector(WEB_COMPONENT_GZ_TITLE);

    this.getTranslations();
    this.setTranslatedStrings();
  }

  public getTranslations(): void {
    this.translations = this.stringsTranslator.getXdrSearchStrings();
  }

  public setTranslatedStrings(): void {
    this.dom.$historicalGzTab.label = this.translations.historicalGzTab;
    this.dom.$liveGzTab.label = this.translations.liveGzTab;
    this.dom.$tabGroupTitle.innerText = this.translations.searchTabGroup;
  }

  public buildSuccessView(data: ViewData): void {
    const nirvanaDep = _.cloneDeep(this.dependencies);
    nirvanaDep.api.type = API_TYPE_NIRVANA;
    this.dom.$searchApp.injectDependencies({
      ...nirvanaDep,
      componentName: 'historical-search',
    });
    const gzdep = _.cloneDeep(this.dependencies);
    gzdep.api.type = API_TYPE_GZ;
    this.dom.$searchLive.injectDependencies({
      ...gzdep,
      componentName: 'live-search',
    });

    if (data.activeTabId) {
      this.selectActiveTabAfterBuildView(data.activeTabId);
    }

    if (data.pivoting.isPivoting) {
      this.handleLiveSearchPivoting(data);
    }

    // start all sub-components
    Promise.all([this.dom.$searchApp.start(), this.dom.$searchLive.start()]).then().catch(console.error);
  }

  private handleLiveSearchPivoting(data: ViewData): void {
    if (data.pivoting.errorMessage) {
      this.dom.$searchLive.controller.buildToastNotification(this.dependencies.translateFn(data.pivoting.errorMessage), ToastSeverity.ERROR);
      return;
    }

    this.dom.$searchLive.controller.setPivotingParams(data.pivoting.params, data.pivoting.pivotingToLoadedComponent);
  }

  protected selectActiveTabAfterBuildView(tabId: string): void {
    const tabGroup = this.dom.$tabGroup;
    const tabs = tabGroup.tabs;
    for (let tabIndex = 0; tabIndex < tabs.length; tabIndex++) {
      const tab = tabs[tabIndex];
      if (tab.id === tabId) {
        tabGroup.selectTab(tabIndex, true)
        return;
      }
    }
    console.warn("Configured active tab [" + tabId + "] was not found!");
  }

}
